import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import useListTruncator from 'hooks/useListTruncator'
import { rem } from 'polished'
import type { MouseEventHandler, ReactElement } from 'react'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import SearchTileRowInclusionItem from './SearchTileRowInclusionItem'
import clsx from 'clsx'

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(${rem(160)}, 1fr));
  gap: ${rem(4)};

  &.singleColumn {
    grid-template-columns: 1fr;
  }
`

interface Props {
  amenities: Array<App.OfferInclusion>
  amenitiesTitle?: string | ReactElement
  onMoreClick?: () => void
  truncateAfter?: number
  singleColumn?: boolean
}

function SearchTileStackAmenitiesList({
  amenities,
  amenitiesTitle,
  onMoreClick,
  truncateAfter = 6,
  singleColumn,
}: Props) {
  const intl = useIntl()
  const [visible, hidden] = useListTruncator(truncateAfter, amenities)

  const handleMoreClick = useCallback<MouseEventHandler<HTMLAnchorElement>>((event) => {
    event.preventDefault()
    onMoreClick?.()
  }, [onMoreClick])

  if (!visible.length) return null

  return <Group direction="vertical" gap={4}>
    {!!amenitiesTitle && <BodyText variant="medium" weight="bold">{amenitiesTitle}</BodyText>}
    <Container className={clsx({ singleColumn })}>
      {visible.map((amenity) => <SearchTileRowInclusionItem
        key={amenity.id}
        inclusion={amenity}
        lineClamp={1}
      />)}
    </Container>
    {(!!hidden.length && onMoreClick) && <TextLink size="medium" onClick={handleMoreClick}>{intl.formatMessage({
      id: 'zAzd5T_wazkA5qZCVrbt',
      defaultMessage: '+{count} more',
      description: 'Link to show more truncated amenities on search tile',
    }, { count: hidden.length })}
    </TextLink>}
  </Group>
}

export default SearchTileStackAmenitiesList
